import axios from "axios";
import { CONSTANTS } from "../../config/constants";
import {
  ACCESS_TOKEN,
  REFRESH_TOKEN,
  getToken,
  removeToken,
  saveToken,
  LANGUAGE_TOKEN,
} from "./tokenUtils";
import { endPoints } from "../../Authentication/services/endPoints";
import { LOGIN_PATH } from "../../Authentication/constants/NavigationConstants";
export const Backend = axios.create({
  baseURL: CONSTANTS.BASE_API_URL,
  responseType: "json",
});

//request interceptor to add the auth token header to requests
Backend.interceptors.request.use(config => {
  if (config.url === endPoints.login) {
    return config;
  }
  const accessToken = getToken(ACCESS_TOKEN);
  const language = getToken(LANGUAGE_TOKEN);

  if (accessToken) {
    config.headers["x-access-token"] = accessToken;
  }
  if (language) {
    config.headers["Accept-Language"] = language;
  }
  return config;
});

//response interceptor to refresh token on receiving token expired error
Backend.interceptors.response.use(
  response => {
    return response;
  },
  function (error) {
    const originalRequest = error.config;
    if (
      error?.response?.status === 401 &&
      !originalRequest._retry &&
      ![endPoints.login].includes(originalRequest.url)
    ) {
      removeToken(ACCESS_TOKEN);
      let refreshToken = getToken(REFRESH_TOKEN);
      if (!refreshToken) {
        window.location.href = LOGIN_PATH;
        return;
      }
      originalRequest._retry = true;
      return axios
        .post(`${CONSTANTS.BASE_API_URL}${endPoints.refreshToken}`, {
          refreshToken: refreshToken,
        })
        .then(res => {
          if (res.status === 200) {
            let { accessToken, refreshToken } = res.data;
            saveToken(accessToken, ACCESS_TOKEN);
            saveToken(refreshToken, REFRESH_TOKEN);
            return Backend(originalRequest);
          }
        })
        .catch(function (err) {
          if (err.response.status === 401) {
            removeToken(REFRESH_TOKEN);
            window.location.href = LOGIN_PATH;
            return;
          }
        });
    }
    return Promise.reject(error);
  }
);
